import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request whose failure the caller reports itself.
 *
 * Every app's ErrorInterceptor snackbars the backend's own `info.message` for any API error, which
 * is the right default but the wrong answer where the component has a localized, better-placed
 * message of its own — the portal's ticket cancel, for one. It lives here rather than in an app so a
 * shared lib can set it; `apps/pauly-auth/src/app/errors/error.interceptor.ts` re-exports it for the
 * callers that already import it from there.
 */
export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
